import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../utils';
import axios from 'axios';

const initialState = {
  loading: false,
  data: {
    content: [],
  },
  visitDetail: null,
  opticalPrescription: null,
  opticalRxLoading: false,
  visitLookup: {},
  visitLoading: false,
  visitError: '',
};

export const searchVisits = createAsyncThunk('searchVisits', async (searchItem) => {
  let token = localStorage.getItem('x-auth-token');

  const searchObj = {};
  if (searchItem.search) {
    const key = Object.keys(searchItem.search);
    if (key[0] === 'Visit ID') {
      searchObj.visitId = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Member No.') {
      searchObj.memberNumber = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Member Name') {
      searchObj.memberName = Object.values(searchItem.search)[0];
    }
  }

  let filterStr = '';
  if (searchItem.filters) {
    console.log(searchItem.filters);
    const keys = Object.keys(searchItem.filters);
    if (keys.indexOf('startDate') !== -1) {
      filterStr = filterStr + `&fromDate=${searchItem.filters['startDate']}`;
    }
    if (keys.indexOf('endDate') !== -1) {
      filterStr = filterStr + `&toDate=${searchItem.filters['endDate']}`;
    }
    if (keys.indexOf('doctor') !== -1) {
      filterStr = filterStr + `&attendingDoctorName=${searchItem.filters['doctor']}`;
    }
  }
  try {
    const response = await axios.get(
      `${baseUrl}/provider/visit/search?${Object.keys(searchObj).length > 0
        ? `${Object.keys(searchObj)[0]}=${Object.values(searchObj)[0]} `
        : ''
      }${filterStr}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getVisits = createAsyncThunk('getVisits', async ({ pagination, status }) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios.get(
      `${baseUrl}/provider/visit?${status ? `status=${status}&` : ''
      }sort=visitCreatedOn,desc&page=${pagination?.page}&size=${pagination?.pageSize}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getVisitsDetailById = createAsyncThunk('getVisitsDetailById', async (id) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios.get(`${baseUrl}/provider/visit/${id}/detail?sublimit=true`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

// Screen 12 — dedicated call for the member's optical prescription attached to
// the visit detail. Kept separate from getVisitsDetailById (which uses
// ?sublimit=true for benefits) so the Rx fetch is unaffected by that flag.
export const getVisitOpticalPrescription = createAsyncThunk(
  'getVisitOpticalPrescription',
  async (id) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const response = await axios.get(`${baseUrl}/provider/visit/${id}/detail`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const wrapper = response.data?.result?.optical_prescription;
      if (!wrapper) return null;
      // Backend returns a wrapper: { prescription_id, optical_prescription: {...rx} }.
      // Flatten to one object (rx fields + prescription_id) so the card can read it
      // directly. Also tolerates the older flat shape (rx fields on the wrapper).
      const inner = wrapper.optical_prescription || wrapper;
      return {
        ...inner,
        prescription_id:
          wrapper.prescription_id ?? inner.prescription_id ?? inner.id ?? inner.rx_id,
      };
    } catch (error) {
      console.log(error);
      return null;
    }
  },
);

export const getPreAuthsWithFilter = createAsyncThunk('preAuths/filter', async (args) => {
  let token = localStorage.getItem('x-auth-token');

  try {
    const response = await axios.get(
      `${baseUrl}/provider/preauth/list?page=${args.page}&size=${args.size}&sort=createdTimestamp,desc&status=${args.filter}&patientType=${args.type}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getMemberStatusAndInfo = createAsyncThunk('searchMember/preAuths', async (numb) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios.get(
      `${baseUrl}/provider/search/submission-status/${numb}?memberInformation=true`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const newPreAuth = createAsyncThunk('addNewPreAuths', async ({ data, handleFinish }) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios({
      method: 'POST',
      url: `${baseUrl}/provider/preauth/create`,
      data: JSON.stringify(data),
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    handleFinish();
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const preAuthSearch = createAsyncThunk('preAuth/preAuthSearch', async (e) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const { data } = await axios({
      method: 'GET',
      url: `${baseUrl}/provider/preauth/search?query=${e}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
  }
});

export const visitDetail = createAsyncThunk('preAuth/visitDetail', async (visitId) => {
  return await axios({
    method: 'POST',
    url: `${baseUrl}/pharmacy/lookup/visit/${visitId}`,
    // url: `${baseUrl}/pharmacy-claim/visit/${visitId}`,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('x-auth-token')}`,
    },
  })
    .catch(e => e)
});

export const PreAuthSlice = createSlice({
  name: 'visits',
  initialState: initialState,
  reducers: {
    resetError: (state) => {
      state.visitError = '';
    },
  },
  extraReducers(builder) {
    //AsyncReducers start here
    //Get Pre-auth
    builder.addCase(getVisits.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVisits.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.data = action.payload?.result;
      } else {
        state.data = {
          content: [],
        };
      }
    });
    builder.addCase(getVisits.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });
    // searchVisits
    builder.addCase(searchVisits.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchVisits.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.data = action.payload?.result;
      } else {
        state.data = {
          content: [],
        };
      }
    });
    builder.addCase(searchVisits.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });
    //Get Pre-auth with Filter
    builder.addCase(getPreAuthsWithFilter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPreAuthsWithFilter.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.result) {
        state.data = action.payload.result;
      } else {
        state.data = initialState.data;
      }
    });
    builder.addCase(getPreAuthsWithFilter.rejected, (state) => {
      state.loading = false;
    });
    //PreAuth member search
    builder.addCase(getMemberStatusAndInfo.pending, (state) => {
      state.member.isSearchLoading = true;
    });
    builder.addCase(getMemberStatusAndInfo.fulfilled, (state, action) => {
      state.member.isSearchLoading = false;
      state.member.isSearchLoaded = true;
      if (!action.payload.result) {
        state.member.error = action.payload.message;
      } else {
        if (action.payload?.result.pre_auth === false) {
          state.member.error = false;
          state.member.data = action.payload?.result?.member;
        } else {
          state.member.error = 'An existing pre-auth already exists for Member number';
        }
      }
    });
    builder.addCase(getMemberStatusAndInfo.rejected, (state) => {
      state.loading = false;
    });
    //PreAuth search
    builder.addCase(preAuthSearch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(preAuthSearch.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.result) {
        state.data = action.payload.result;
      } else {
        state.data = initialState.data;
      }
    });
    builder.addCase(getVisitsDetailById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVisitsDetailById.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        // Preserve the envelope timestamp (visit date) alongside the result so
        // downstream screens (e.g. Bill & Submit Claim) can use it.
        state.visitDetail = {
          ...action.payload.result,
          timestamp: action.payload.result?.timestamp || action.payload.timestamp,
        };
      }
    });
    builder.addCase(getVisitsDetailById.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getVisitOpticalPrescription.pending, (state) => {
      state.opticalRxLoading = true;
    });
    builder.addCase(getVisitOpticalPrescription.fulfilled, (state, action) => {
      state.opticalRxLoading = false;
      state.opticalPrescription = action.payload || null;
    });
    builder.addCase(getVisitOpticalPrescription.rejected, (state) => {
      state.opticalRxLoading = false;
      state.opticalPrescription = null;
    });

    // visitDetail
    builder.addCase(visitDetail.pending, (state) => {
      state.visitLoading = true;
    });
    builder.addCase(visitDetail.fulfilled, (state, action) => {
      state.visitLoading = false;
      const res = action?.payload?.response?.data || action?.payload?.data;
      if (res.api.responseCode === 2040) {
        state.visitLookup = res?.result;
        localStorage.setItem('visitLookup', JSON.stringify(res?.result));
      } else {
        state.visitLookup = {};
        state.visitError = res?.message;
      }
    });
    builder.addCase(visitDetail.rejected, (state, action) => {
      state.visitLoading = false;
      state.visitError = action?.error?.message;
    });
  },
});

export const { resetMember, addMemberError, resetError } = PreAuthSlice.actions;

export default PreAuthSlice.reducer;
